import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Detector } from "react-detect-offline";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { initializeApp } from "firebase/app";
import { useSelector } from "react-redux";
import { isEmpty, isObject } from "lodash";
import { useMediaQuery, useTheme } from "@mui/material";
import Signup from "./pages/Signup";
import CreateProfile from "./pages/CreateProfile";
import ResetPassword from "./pages/ResetPassword";
import OtpInput from "./pages/OtpInput";
import PhoneVerify from "./pages/PhoneVerify";
import Footer from "./components/Footer";
import NotificationPopup from "./components/NotificationPopUp";
import "./App.css";
import ContractorProfile from "./pages/ContractorProfile";
import AccountSettings from "./pages/AccountSettings";
import Billing from "./pages/Billing";
import ContractorBilling from "./pages/ContractorBilling";
import UserManagement from "./pages/UserManagement";
import HomeownerTermsAndConditions from "./pages/HomeownerTermsAndConditions";
import ContractorDocuments from "./pages/ContractorDocuments";
import DesignerDocuments from "./pages/DesignerDocuments";
import Payments from "./pages/Payments";
import Packages from "./pages/Packages";
import Proposals from "./pages/Proposals";
import Projects from "./pages/Projects";
import DrawerComponent from "./components/Drawer";
import ProjectBalance from "./pages/ProjectBalance";
import NewProjectDetails from "./pages/NewProjectDetails";
import ProjectUpdateRoute from "./pages/NewProjectDetails/components/ProjectUpdates/ProjectUpdateRoute";
import MilestoneDetails from "./pages/NewProjectDetails/components/Milestones/MilestoneDetails";
import NewProposalDetails from "./pages/NewProposalDetails";
import NewCreateProposal from "./pages/NewCreateProposal";
import RFCs from "./pages/RFCs";
import RFCPricing from "./pages/RFCPricing";
import RequestForApproval from "./pages/RequestForApproval";
import ChangeRequest from "./pages/ChangeRequest";
import RequestForPayment from "./pages/RequestForPayment";
import OurDeliveryMemo from "./pages/OurDeliveryMemo";
import Customers from "./pages/Customers";
import ProposalMilestoneDetails from "./pages/NewCreateProposal/components/Milestones/components/ProposalMilestoneDetails";
import NewPackageDetails from "./pages/NewPackageDetails";
import InclusionDetails from "./pages/NewPackageDetails/components/Inclusions/InclusionDetails";
import NewCreatePackage from "./pages/NewCreatePackage";
import PackageInclusionDetails from "./pages/NewCreatePackage/components/Inclusions/components/PackageInclusionDetails";
import SupplierDocuments from "./pages/SupplierDocuments";
import NewLogin from "./pages/NewLogin";
import HomeScreen from "./pages/HomeScreen";
import ForgotPassword from "./pages/ForgotPassword";
import RoleSelection from "./pages/RoleSelection";
import MilestoneSnagDetails from "./pages/NewProjectDetails/components/Inspections/MilestoneSnagDetails";
import BOMSummaryDetails from "./pages/BOMSummaryDetails";
import RoomDetails from "./pages/RoomDetails";
import RFQs from "./pages/RFQs";
import RFQPricing from "./pages/RFQPricing";
import RFQDesignPricing from "./pages/RFQDesignPricing";
import ActivitiesDetails from "./pages/NewProjectDetails/components/Schedule/ActivitiesDetails";
import ScheduleEditor from "./pages/NewProjectDetails/components/Schedule/ScheduleEditor";
import ActivityDetails from "./pages/NewProjectDetails/components/Schedule/ActivityDetails";
import EditProfileForm from "./pages/EditProfileForm";
import SetupAccount from "./pages/SetupAccount";
import WorkforceManagement from "./pages/WorkforceManagement";

const firebaseConfig = {
  apiKey: "AIzaSyDeJrr2C4h4tIh7Hj0L4-qa1QwRBTfyHXM",
  authDomain: "reno-home.firebaseapp.com",
  projectId: "reno-home",
  storageBucket: "reno-home.appspot.com",
  messagingSenderId: "271291217173",
  appId: "1:271291217173:web:7a4260dcb3527e5869651c",
  measurementId: "G-FL6WQC501W",
};

function App() {
  initializeApp(firebaseConfig);
  const { userData } = useSelector((state) => state.auth);
  const [isLogin, setIsLogin] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (isObject(userData) && !isEmpty(userData)) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [userData]);

  {
    console.log("env", process.env.REACT_APP_LOCALE);
  }

  return (
    <Detector
      interval={10000}
      render={({ online }) => {
        return (
          <Router>
            <Routes>
              <Route
                path="/homeowner-terms-and-conditions"
                element={<HomeownerTermsAndConditions />}
              />
              <Route path={"/account-password"} element={<SetupAccount />} />
              <Route
                path="/"
                element={
                  <div
                    style={{
                      display: "flex",
                      height: "100vh",
                      boxSizing: "border-box",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        overflow: "hidden",
                      }}
                    >
                      <DrawerComponent />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          height: "100vh",
                          overflowY: "auto",
                          paddingTop: isMobile ? "55px" : "0",
                        }}
                        className={isMobile ? "main-content-area" : ""}
                      >
                        <Outlet />
                      </div>
                    </div>
                    <Footer />
                  </div>
                }
              >
                {isLogin ? (
                  <>
                    <Route path={"/otp-verify"} element={<OtpInput />} />
                    <Route
                      path={"/create-profile"}
                      element={<CreateProfile />}
                    />
                    <Route path={"/dashboard"} element={<Projects />} />
                    <Route
                      path="/new-create-proposal/:id?/:tab?"
                      element={<NewCreateProposal />}
                    />
                    <Route
                      path={"/new-create-proposal/:id/milestone/:milestoneId"}
                      element={<ProposalMilestoneDetails />}
                    />
                    <Route
                      path={"/project/details/:id/:tab?"}
                      element={<NewProjectDetails />}
                    />
                    <Route
                      path={"/project/details/:id/milestone/:milestoneId"}
                      element={<MilestoneDetails />}
                    />
                    <Route
                      path={"/project/details/:id/snag/:visitId"}
                      element={<MilestoneSnagDetails />}
                    />
                    <Route
                      path={"/project/details/:id/bom-summary/:scopeId"}
                      element={<BOMSummaryDetails />}
                    />
                    <Route
                      path={"/project/details/:id/room/:roomId"}
                      element={<RoomDetails />}
                    />
                    <Route
                      path={
                        "/project/details/:id/scopes/:scopeId/activities-details"
                      }
                      element={<ActivitiesDetails />}
                    />
                    <Route
                      path={
                        "/project/details/:id/scopes/:scopeId/schedule-editor"
                      }
                      element={<ScheduleEditor />}
                    />
                    <Route
                      path={"/project/details/:id/schedule/details/:activityId"}
                      element={<ActivityDetails />}
                    />
                    <Route
                      path={"/project/details/:id/project-updates/:updateId"}
                      element={<ProjectUpdateRoute />}
                    />
                    <Route
                      path={
                        "/project/details/:id/billing-milestones/:milestoneId/request-approval"
                      }
                      element={<RequestForApproval />}
                    />
                    <Route
                      path={
                        "/project/details/:id/billing-milestones/:milestoneId/request-payment"
                      }
                      element={<RequestForPayment />}
                    />
                    <Route
                      path={
                        "/project/details/:id/billing-milestones/:groupId/our-delivery-memo"
                      }
                      element={<OurDeliveryMemo />}
                    />
                    <Route
                      path={"/project/details/:id/changes/new"}
                      element={<ChangeRequest />}
                    />
                    <Route
                      path={"/project/details/:id/changes/:crId"}
                      element={<ChangeRequest />}
                    />
                    <Route path={"/rfqs"} element={<RFQs />} />
                    <Route
                      path={"/rfq/pricing/:id/:bidId"}
                      element={<RFQPricing />}
                    />
                    <Route
                      path={"/rfq/design-pricing/:id/:bidId"}
                      element={<RFQDesignPricing />}
                    />
                    <Route
                      path={"/contractor/proposals"}
                      element={<RFCs />}
                    />
                    <Route
                      path={"/contractor/proposal/new"}
                      element={<RFCPricing />}
                    />
                    <Route
                      path={"/contractor/proposal/:proposalId"}
                      element={<RFCPricing />}
                    />
                    <Route
                      path={"/rfc/pricing/:id/:bidId"}
                      element={<RFCPricing />}
                    />
                    <Route path={"/customers"} element={<Customers />} />
                    <Route
                      path={"/proposal/details/:id/:tab?"}
                      element={<NewProposalDetails />}
                    />
                    <Route
                      path={"/package/details/:id/inclusion/:inclusionId"}
                      element={<InclusionDetails />}
                    />
                    <Route
                      path={"/package/details/:id/:tab?"}
                      element={<NewPackageDetails />}
                    />
                    <Route
                      path="/new-create-package/:id?/:tab?"
                      element={<NewCreatePackage />}
                    />
                    <Route
                      path={"/new-create-package/:id/inclusion/:milestoneId"}
                      element={<PackageInclusionDetails />}
                    />
                    <Route
                      path={"/contractor-profile"}
                      element={<ContractorProfile />}
                    />
                    <Route
                      path={"/account-setting"}
                      element={<AccountSettings />}
                    />
                    <Route
                      path={"/edit-profile-form"}
                      element={<EditProfileForm />}
                    />
                    <Route
                      path={"/account-setting/users"}
                      element={<UserManagement />}
                    />
                    <Route path={"/billing"} element={<Billing />} />
                    <Route
                      path={"/contractor-billing"}
                      element={<ContractorBilling />}
                    />
                    {/* <Route
                        path={"/create-proposal"}
                        element={<CreateProposal />}
                      />
                      <Route path={"/ongoing-project"} element={<OnGoing />} />
                      <Route
                        path={"/request-proposal"}
                        element={<RequestedProposal />}
                      /> */}
                    <Route
                      path={"/balance-breakdown"}
                      element={<ProjectBalance />}
                    />
                    <Route path={"/payments"} element={<Payments />} />
                    <Route path={"/packages"} element={<Packages />} />
                    {/* <Route path={"/proposals"} element={<Proposals />} /> */}
                    <Route
                      path={"/contractor-documents"}
                      element={<ContractorDocuments />}
                    />
                    <Route
                      path={"/designer-documents"}
                      element={<DesignerDocuments />}
                    />
                    <Route
                      path={"/supplier-documents"}
                      element={<SupplierDocuments />}
                    />
                    <Route
                      path={"/user-management"}
                      element={<UserManagement />}
                    />
                    <Route
                      path={"/workforce-management"}
                      element={<WorkforceManagement />}
                    />
                    <Route path={"/role"} element={<RoleSelection />} />
                    <Route
                      index
                      element={
                        <Navigate
                          to={
                            userData?.contractor_data &&
                            userData?.contractor_data?.profile_completed ===
                              "pending"
                              ? "/create-profile"
                              : "/dashboard"
                          }
                        />
                      }
                      replace
                    />
                    <Route
                      path="*"
                      element={
                        <Navigate
                          to={
                            userData?.contractor_data &&
                            userData?.contractor_data?.profile_completed ===
                              "pending"
                              ? "/create-profile"
                              : "/dashboard"
                          }
                        />
                      }
                    />{" "}
                  </>
                ) : (
                  <>
                    <>
                      <Route index element={<Navigate to="/login" replace />} />
                      <Route path={"/login"} element={<HomeScreen />} />
                      <Route path={"/user-login"} element={<NewLogin />} />

                      <Route path={"/signup"} element={<Signup />} />
                      <Route
                        path={"/reset-password"}
                        element={<ResetPassword />}
                      />
                      <Route
                        path={"/forgot-password"}
                        element={<ForgotPassword />}
                      />

                      <Route path={"/otp-verify"} element={<OtpInput />} />
                      <Route path={"/phone-verify"} element={<PhoneVerify />} />

                      <Route path={"/role"} element={<RoleSelection />} />
                      <Route path="*" element={<Navigate to={"/"} />} />
                    </>
                  </>
                )}
              </Route>
            </Routes>
            <NotificationPopup />
            <ToastContainer
              autoClose={3000}
              pauseOnFocusLoss={false}
              toastClassName="toastStyle"
            />
          </Router>
        );
      }}
    />
  );
}

export default App;
